module.exports = __webpack_public_path__ + "img/stand_up.6ea1586c.png";